import React, { useEffect, useState } from "react";
import Button from "../../../components/Buttons/Button";
import TextboxField from "../../../components/Fields/TextboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { DataResult, Result } from "../../../types/Result";

interface WorkflowChangeStatusModel {
    workflowIds: number[]
    reason: string
}

interface IProps {
    show: boolean
    onHide: () => void
    workflowId: number
}

const SuspendWorkflowPopup: React.FC<IProps> = ({ show, onHide, workflowId }) => {
    const defaultFormData = {
        workflowIds: [workflowId],
        reason: ''
    }
    const [formData, setFormData] = useState<WorkflowChangeStatusModel>(defaultFormData);
    const [serverErrors, setServerErrors] = useState<DataResult<WorkflowChangeStatusModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    useEffect(() => {
        setFormData(defaultFormData);
    }, [show]);

    function submit() {
        if (formData) {
            DataService
                .post<Result>(`api/v1/Workflow/SuspendWorkflows`, formData)
                .then(response => {
                    handleResult(response);
                    if (response.isSuccesful === true && onHide) {
                        onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    function onFieldChanged(name: string, value: string): void {
        formData[name] = value;
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'reason', label: 'Reason', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Suspend workflow'} >
            <Popup.Body>
                <TextboxField {...getFieldProps('reason')} />
            </Popup.Body>
            <Popup.Footer>
                <Button {...getSubmitButtonProps()} text='Suspend workflow' fill/>
            </Popup.Footer>
        </Popup>
    );
}
export default SuspendWorkflowPopup;